import { useRoute } from 'vue-router';
import { useModal } from '@/storybook/modal/useModal';

import { useItemActions } from './useItemActions';
import ViewsLimit from '@/modules/viewer/components/limitations/ViewsLimit.vue';
import ViewOnlyUserModal from '@/modules/viewer/components/limitations/ViewOnlyUserModal.vue';

export const useViewerModals = () => {
  /**
   * Open modal from URL query params
   */
  const openModalFromUrlQuery = () => {
    const { addToCollectionAction, openShareModalAction, openVersionsModalAction } = useItemActions();
    const route = useRoute();
    const { query } = route;

    // classic viewer => show_share: securityModal,
    if (query.show_share || query.show_sharing || query.show_embed) {
      openShareModalAction();
    }

    if (query.show_collection) {
      addToCollectionAction();
    }

    if (query.show_versions) {
      openVersionsModalAction();
    }
  };

  const showLimitReachedModal = () => {
    const { open } = useModal(ViewsLimit);
    return open();
  };

  const showViewOnlyUserModal = () => {
    const { open } = useModal(ViewOnlyUserModal);
    return open();
  };

  return { openModalFromUrlQuery, showLimitReachedModal, showViewOnlyUserModal };
};
